(function () {
  var widgetId = 'eventbrite-widget-container-1137916852939';
  var scriptUrl = 'https://www.eventbrite.ca/static/widgets/eb_widgets.js';

  function initializeEventbrite() {
    var container = document.getElementById(widgetId);
    if (!container || container.dataset.initialized === 'true') return;
    if (!window.EBWidgets) {
      var script = document.querySelector('script[data-tcr-eventbrite]');
      if (!script) {
        script = document.createElement('script');
        script.src = scriptUrl;
        script.defer = true;
        script.dataset.tcrEventbrite = 'true';
        script.onload = initializeEventbrite;
        document.head.appendChild(script);
      }
      return;
    }
    container.dataset.initialized = 'true';
    window.EBWidgets.createWidget({
      widgetType: 'checkout',
      eventId: '1137916852939',
      iframeContainerId: widgetId,
      iframeContainerHeight: window.matchMedia('(max-width: 520px)').matches ? 500 : 600,
      onOrderComplete: function () {}
    });
  }

  function scrollToRequestedBooking() {
    if (new URLSearchParams(window.location.search).get('section') !== 'booking') return;
    var booking = document.getElementById('tcr-booking');
    if (booking) window.setTimeout(function () { booking.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 300);
  }

  function ready() {
    initializeEventbrite();
    scrollToRequestedBooking();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
  document.addEventListener('shopify:section:load', initializeEventbrite);
}());
